import { Button, Text, Box, Input } from "@chakra-ui/react"
import WithAuth from "../components/hoc/with-auth"
import { AuthLayout } from "../components/layouts"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx"
import DealsPage from "../components/pages/deals-page/index"

const Deals = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar pageTitle="Accounts" pageDesc="List of all the accounts">
          <DealsPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default Deals
